import React from "react";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import { makeStyles } from "@material-ui/core/styles";

// Editor das ENTRADAS do agente: os dados que o FLUXO informa ao iniciar a ligação
// (ex.: nome do cliente). O agente recebe esses valores no começo da conversa. Quem
// PREENCHE os valores é o nó "Transferir para IA" (mapeia cada entrada → variável).
const useStyles = makeStyles(theme => ({
  hint: { fontSize: 12.5, color: theme.app.textSecondary, marginBottom: 10 },
  row: { border: `1px solid ${theme.app.border}`, borderRadius: 10, padding: 10, marginBottom: 10, background: "#fff" },
  top: { display: "flex", gap: 8, alignItems: "center" },
  name: { flex: 1 },
  desc: { marginTop: 8 },
  empty: { fontSize: 12.5, color: theme.app.textTertiary, padding: "6px 0 12px" },
  code: { fontFamily: "monospace", fontSize: 12 },
}));

const slug = s =>
  (s || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-zA-Z0-9_]/g, "_")
    .replace(/_{2,}/g, "_")
    .replace(/^_+/, "");

const AgentInputEditor = ({ value, onChange }) => {
  const classes = useStyles();
  const fields = Array.isArray(value) ? value : [];

  const patch = (i, key, v) => onChange(fields.map((f, idx) => (idx === i ? { ...f, [key]: v } : f)));
  const add = () => onChange([...fields, { name: "", description: "" }]);
  const remove = i => onChange(fields.filter((_, idx) => idx !== i));

  return (
    <div>
      <Typography className={classes.hint}>
        Dados que o FLUXO informa ao iniciar a conversa (ex.: nome do cliente), na voz e no WhatsApp. A IA recebe
        esses valores no começo e pode usar na persona como <span className={classes.code}>{"{{nome}}"}</span>. Os valores
        são preenchidos no nó <b>Transferir para IA</b> (ligação) ou <b>Iniciar conversa com agente de IA</b> (WhatsApp).
        Se a conversa começar sem esses dados (ex.: o cliente escreveu primeiro), o <span className={classes.code}>{"{{nome}}"}</span> fica vazio.
      </Typography>

      {fields.length === 0 && (
        <Typography className={classes.empty}>Nenhuma entrada. O agente não recebe dados do fluxo.</Typography>
      )}

      {fields.map((f, i) => (
        <div key={i} className={classes.row}>
          <div className={classes.top}>
            <TextField
              className={classes.name}
              label="Nome"
              placeholder="nome"
              value={f.name || ""}
              onChange={e => patch(i, "name", slug(e.target.value))}
              size="small"
              variant="outlined"
            />
            <IconButton size="small" onClick={() => remove(i)} title="Remover">
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>
          <TextField
            className={classes.desc}
            label="Descrição (a IA lê para saber o que é)"
            placeholder="Nome do cliente"
            value={f.description || ""}
            onChange={e => patch(i, "description", e.target.value)}
            size="small"
            variant="outlined"
            fullWidth
          />
        </div>
      ))}

      <Button size="small" variant="outlined" color="secondary" startIcon={<AddIcon />} onClick={add}>
        Adicionar entrada
      </Button>
    </div>
  );
};

export default AgentInputEditor;
